import {
  createServiceAreaPage,
  createServiceAreaStaticPaths,
  createServiceAreaStaticProps,
} from '@lib/createServiceAreaPage';

const PlumbingAreaPage = createServiceAreaPage({
  servicePath: 'plumbing',
  baseUrl: 'https://www.qeeper.co.uk',
});

export const getStaticPaths = createServiceAreaStaticPaths;
export const getStaticProps = createServiceAreaStaticProps('plumbing');

export default PlumbingAreaPage;
